import React, { Component } from 'react';
import browserHistory from '../../history';
import { connect } from 'react-redux';
import CookieConsent from "react-cookie-consent";

const footerSections = [
    {
        title: 'COMPANY',
        links: [
            { label: 'About Us', route: '/about' },
            { label: 'Careers', route: '/careers' },
            { label: 'Contact Us', route: '/contactUs' },
        ],
    },
    {
        title: 'SUPPORT',
        links: [
            { label: 'Help Center', route: '/help' },
            { label: 'Supported Devices', route: '/devices' },
            { label: 'Activate Your Device', route: '/activate' },
            { label: 'Accessibility', route: '/accessibility' },
        ],
    },
    {
        title: 'PARTNERS',
        links: [
            { label: 'Advertise with Us', route: '/advertise' },
            { label: 'Partner with Us', route: '/partners' },
        ],
    },
    {
        title: 'GET THE APPS',
        links: [
            { label: 'Apple TV', storeKey: 'iTunesAppStore', route: '/ios' },
            { label: 'Android TV', storeKey: 'googleAppStore', route: '/android' },
            { label: 'Roku TV', storeKey: 'rokuAppStore', route: '/roku' },
            { label: 'Fire TV', storeKey: 'amazonAppStore', route: '/amazon' },
        ],
    },
    {
        title: 'PRESS',
        links: [
            { label: 'Press Releases', route: '/press' },
            { label: 'Envoi in the News', route: '/news' },
        ],
    },
    {
        title: 'LEGAL',
        links: [
            { label: 'Privacy Policy', route: '/privacy' },
            { label: 'Terms of Use', route: '/terms' },
            { label: 'Your Privacy Choices', route: '/privacy-choices' },
            { label: 'Cookies', route: '/cookies' },
        ],
    },
];

const socialIcons = [
    {
        name: 'Facebook',
        href: 'https://www.facebook.com/screenixx',
        svg: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
            </svg>
        ),
    },
    {
        name: 'Instagram',
        href: 'https://www.instagram.com/screenixx',
        svg: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
            </svg>
        ),
    },
    // {
    //     name: 'Twitter',
    //     href: 'https://twitter.com/screenixx',
    //     svg: (
    //         <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    //             <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
    //         </svg>
    //     ),
    // },
    {
        name: 'LinkedIn',
        href: '#',
        svg: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                <circle cx="4" cy="4" r="2" />
            </svg>
        ),
    },
    {
        name: 'Youtube',
        href: 'https://www.youtube.com/@Screenixx',
        svg: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-1.96C18.88 4 12 4 12 4s-6.88 0-8.6.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.94 1.96C5.12 20 12 20 12 20s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
    <polygon points="10 15 15 12 10 9 10 15" fill="currentColor"/>
</svg>
        ),
    }
];

const styles = {
    footer: {
        backgroundColor: '#0d0d1f',
        color: '#ffffff',
        fontFamily: 'inherit',
        width: '100%',
    },
    topBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 40px',
    },
    breadcrumb: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        color: '#cccccc',
    },
    breadcrumbSep: {
        color: '#666',
    },
    socialRow: {
        display: 'flex',
        gap: '18px',
        alignItems: 'center',
    },
    socialIcon: {
        color: '#cccccc',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        transition: 'color 0.2s',
    },
    divider: {
        borderColor: '#2a2a3d',
        margin: '0',
        border: 'none',
        borderTop: '1px solid #2a2a3d',
    },
    linksSection: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '32px 40px',
        gap: '24px',
        justifyContent: 'space-between',
    },
    column: {
        minWidth: '130px',
        flex: '1',
    },
    columnTitle: {
        fontSize: '11px',
        fontWeight: '700',
        letterSpacing: '1.5px',
        color: '#ffffff',
        marginBottom: '16px',
        textTransform: 'uppercase',
    },
    columnLink: {
        display: 'block',
        fontSize: '13px',
        color: '#aaaaaa',
        textDecoration: 'none',
        marginBottom: '10px',
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        padding: '0',
        textAlign: 'left',
        transition: 'color 0.2s',
    },
    bottomSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '28px 40px 24px',
        gap: '14px',
    },
    appBadges: {
        display: 'flex',
        gap: '12px',
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    badge: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        backgroundColor: '#000000',
        border: '1px solid #444',
        borderRadius: '8px',
        padding: '8px 16px',
        textDecoration: 'none',
        color: '#ffffff',
        fontSize: '12px',
        cursor: 'pointer',
    },
    badgeSubtext: {
        fontSize: '10px',
        color: '#aaa',
        display: 'block',
        lineHeight: '1.2',
        fontFamily: 'var(--bodyfont, quicksand-regular, sans-serif)',
    },
    badgeText: {
        fontSize: '14px',
        fontWeight: '600',
        display: 'block',
        lineHeight: '1.3',
        fontFamily: 'var(--boldfont, quicksand-bold, sans-serif)',
    },
    copyright: {
        fontSize: '13px',
        color: '#888888',
        textAlign: 'center',
        lineHeight: '1.6',
    },
};

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeMenu: window.location.pathname,
        };
    }

    handleNav = (route) => {
        let appStorage = window.app.storage;
        let appName = appStorage.getItem('appName');
        const usertype = (appStorage.getItem && appStorage.getItem('usertype')) || localStorage.getItem('usertype');
        const resolvedRoute = (route === '/partners' && usertype === 'creator') ? '/creator' : route;
        this.setState({ activeMenu: resolvedRoute });
        browserHistory.push(`${resolvedRoute}?appname=${appName}`);
    };

    render() {
        const currentYear = new Date().getFullYear();
        const siteConfig = (window.site && window.site.config) || {};
        const storeLinks = siteConfig.storeLinks || {};
        const appName = window.app && window.app.appName;
        const isScreenixx = appName === 'screenixx';

        return (
            <React.Fragment>
                <CookieConsent
                    location="bottom"
                    buttonText="ACCEPT"
                    declineButtonText="REJECT"
                    cookieName="acceptCookies"
                    expires={150}
                >
                    <p>We are using cookies to give you the best experience on our website.</p>
                    <p>You can select if you want to accept or reject our cookies to the right.</p>
                    <p>
                        By choosing accept you are consenting to our use of cookies in accordance with our{' '}
                        <a href="/privacy" className="landingAbout">Privacy Policy</a>.
                    </p>
                </CookieConsent>

                <footer style={styles.footer}>
                    {/* Top bar: breadcrumb + social icons */}
                    <div style={styles.topBar}>
                        <div style={styles.breadcrumb}>
                            <span
                                onClick={() => this.handleNav('/')}
                                style={{ cursor: 'pointer', color: '#cccccc' }}
                            >
                                Live TV
                            </span>
                            <span style={styles.breadcrumbSep}>/</span>
                            <span
                                onClick={() => this.handleNav('/movies')}
                                style={{ cursor: 'pointer', color: '#cccccc' }}
                            >
                                Movies &amp; Shows
                            </span>
                        </div>
                        <div style={styles.socialRow}>
                            {socialIcons.map((icon) => (
                                <a
                                    key={icon.name}
                                    href={isScreenixx ? icon.href : '#'}
                                    target={isScreenixx && icon.href !== '#' ? '_blank' : undefined}
                                    rel={isScreenixx && icon.href !== '#' ? 'noopener noreferrer' : undefined}
                                    aria-label={icon.name}
                                    style={styles.socialIcon}
                                    onMouseEnter={e => e.currentTarget.style.color = '#ffffff'}
                                    onMouseLeave={e => e.currentTarget.style.color = '#cccccc'}
                                >
                                    {icon.svg}
                                </a>
                            ))}
                        </div>
                    </div>

                    <hr style={styles.divider} />

                    {/* Multi-column link sections */}
                    <div style={styles.linksSection}>
                        {footerSections.map((section) => (
                            <div key={section.title} style={styles.column}>
                                <div style={styles.columnTitle}>{section.title}</div>
                                {section.links.map((link) => {
                                    const externalUrl = link.storeKey && storeLinks[link.storeKey];
                                    return externalUrl ? (
                                        <a
                                            key={link.label}
                                            href={externalUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={styles.columnLink}
                                            onMouseEnter={e => e.currentTarget.style.color = '#ffffff'}
                                            onMouseLeave={e => e.currentTarget.style.color = '#aaaaaa'}
                                        >
                                            {link.label}
                                        </a>
                                    ) : (
                                        <button
                                            key={link.label}
                                            style={styles.columnLink}
                                            onClick={() => this.handleNav(link.route || '/underConstruction')}
                                            onMouseEnter={e => e.currentTarget.style.color = '#ffffff'}
                                            onMouseLeave={e => e.currentTarget.style.color = '#aaaaaa'}
                                        >
                                            {link.label}
                                        </button>
                                    );
                                })}
                            </div>
                        ))}
                    </div>

                    <hr style={styles.divider} />

                    {/* Bottom: app badges + copyright */}
                    <div style={styles.bottomSection}>
                        <div style={styles.appBadges}>
                            {[
                                {
                                    label: 'Apple TV', subtext: 'Watch on', storeKey: 'iTunesAppStore', fallbackRoute: '/ios',
                                    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>,
                                },
                                {
                                    label: 'Roku TV', subtext: 'Watch on', storeKey: 'rokuAppStore', fallbackRoute: '/roku',
                                    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M11 2C6.477 2 2.85 5.185 2.85 9.15c0 2.31 1.225 4.373 3.15 5.73V20h2v-4.5h8V20h2v-5.12c1.925-1.357 3.15-3.42 3.15-5.73C21.15 5.185 17.523 2 13 2h-2zm0 2h2c3.39 0 6.15 2.314 6.15 5.15S16.39 14.3 13 14.3h-2c-3.39 0-6.15-2.314-6.15-5.15S7.61 4 11 4zm1 2a3 3 0 100 6 3 3 0 000-6zm0 2a1 1 0 110 2 1 1 0 010-2z"/></svg>,
                                },
                                {
                                    label: 'Android TV', subtext: 'Watch on', storeKey: 'googleAppStore', fallbackRoute: '/android',
                                    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M3.18 23.76c.3.17.65.19.96.06l11.94-6.9-2.58-2.59-10.32 9.43zM.32 1.5C.12 1.83 0 2.24 0 2.72v18.56c0 .48.12.89.33 1.22l.06.06 10.4-10.4v-.25L.38 1.45l-.06.05zM20.46 10.7l-2.81-1.63-2.9 2.9 2.9 2.9 2.83-1.64c.81-.47.81-1.23-.02-1.53zM3.18.24L14.5 7.57l-2.58 2.58L.38.72c.31-.25.71-.3 1.05-.1l1.75 1.02z"/></svg>,
                                },
                                {
                                    label: 'Fire TV', subtext: 'Watch on', storeKey: 'amazonAppStore', fallbackRoute: '/amazon',
                                    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M13.234 15.878c-2.105 1.19-4.586 1.817-6.937 1.817-3.282 0-6.236-1.213-8.474-3.217-.176-.158-.019-.373.193-.25 2.413 1.404 5.394 2.248 8.475 2.248 2.079 0 4.365-.431 6.466-1.328.317-.135.583.208.277.73zM14.1 14.847c-.24-.307-1.589-.145-2.197-.073-.184.022-.212-.138-.046-.253 1.076-.756 2.84-.538 3.046-.284.207.254-.054 2.028-.066 2.853-.015.125-.093.182-.2.083-.43-.36-1.309-1.018-1.537-1.326zm-2.748-9.32V4.18A.18.18 0 0111.531 4h7.838a.18.18 0 01.18.18v1.19c0 .1-.086.23-.236.436L15.37 10.9c.582-.013 1.197.073 1.724.373.116.065.148.161.157.255v1.282c0 .1-.11.216-.226.155-1.29-.676-3.002-.748-4.429.008a.226.226 0 01-.236-.15v-1.218c0-.111 0-.3.116-.467l4.296-6.16h-3.742a.18.18 0 01-.18-.18z"/></svg>,
                                },
                            ].map(({ label, subtext, storeKey, fallbackRoute, icon }) => {
                                const url = storeLinks[storeKey];
                                return url ? (
                                    <a key={label} href={url} target="_blank" rel="noopener noreferrer" style={styles.badge}>
                                        {icon}
                                        <div>
                                            <span style={styles.badgeSubtext}>{subtext}</span>
                                            <span style={styles.badgeText}>{label}</span>
                                        </div>
                                    </a>
                                ) : (
                                    <button key={label} style={styles.badge} onClick={() => this.handleNav(fallbackRoute)}>
                                        {icon}
                                        <div>
                                            <span style={styles.badgeSubtext}>{subtext}</span>
                                            <span style={styles.badgeText}>{label}</span>
                                        </div>
                                    </button>
                                );
                            })}
                        </div>

                        <div style={styles.copyright}>
                            <p style={{ margin: '0 0 4px' }}>Copyright &copy; {currentYear} Envoi, Inc. All rights reserved.</p>
                           
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        );
    }
}

const mapState = ({ loading }) => ({ loading });
const mapDispatch = {};
export default connect(mapState, mapDispatch)(Footer);
